import { useState } from "react";
import { Link } from "react-router-dom";
import GossipCard from "@/components/base/GossipCard";
import SectionHeading from "@/components/base/SectionHeading";
import { gossipList } from "@/mocks/gossip";

const tabs = ["全部", "恋情绯闻", "事业动向", "口碑争议"];

export default function LatestChecks() {
  const [tab, setTab] = useState("全部");

  const filtered = (tab === "全部" ? gossipList : gossipList.filter((i) => i.category === tab)).slice(0, 6);

  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="max-w-shell mx-auto px-4 md:px-6 py-12 md:py-16">
        <SectionHeading
          eyebrow="最新鉴定"
          title="刚刚拆完的瓜，结论都在这里"
          description="每条都附上证据链与待确认环节，点进去可以看到我们是怎样一步步得出结论的。"
          action={{ label: "查看全部", to: "/gossip" }}
        />

        <div className="mt-6 flex flex-wrap items-center gap-2 border-b border-background-200 pb-3">
          {tabs.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => setTab(item)}
              className={`px-4 py-2 rounded-control text-sm transition-colors whitespace-nowrap ${
                tab === item
                  ? "bg-foreground-950 text-background-50 font-medium"
                  : "text-foreground-600 hover:bg-background-100"
              }`}
            >
              {item}
            </button>
          ))}
          <span className="ml-auto text-xs text-foreground-400 hidden sm:block">
            共 {filtered.length} 条匹配
          </span>
        </div>

        {filtered.length > 0 ? (
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {filtered.map((item) => (
              <GossipCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <div className="mt-10 border border-dashed border-background-300 rounded-card p-10 text-center">
            <p className="text-sm text-foreground-500">该分类下暂时没有已完成的鉴定条目。</p>
            <Link to="/gossip" className="mt-3 inline-block text-sm text-primary-600 font-medium">
              看看全部爆料
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}